// Group-chat opt-in settings API. Calls the JWT-guarded /settings/group-chat endpoints
// (the user's token is attached automatically by the apiClient). Swaps to a mock when
// VITE_USE_MOCKS. Mirrors the adminApi/authApi pattern.
//
// Backend contract (see SPEC-gruppechat.md §3, src/worker/group.ts):
//   GET  /settings/group-chat            → { ok, optIn: boolean }
//   POST /settings/group-chat { optIn }  → { ok, optIn: boolean }
import { apiClient } from "@/lib/apiClient";
import { env } from "@/lib/env";
import { mockSettingsApi } from "@/mocks/mockSettings";

export interface SettingsApi {
  getOptIn(): Promise<boolean>;
  setOptIn(optIn: boolean): Promise<boolean>;
}

const realSettingsApi: SettingsApi = {
  async getOptIn() {
    const r = await apiClient.get<{ ok: true; optIn: boolean }>("/settings/group-chat");
    return r.optIn;
  },
  async setOptIn(optIn) {
    const r = await apiClient.post<{ ok: true; optIn: boolean }>("/settings/group-chat", {
      optIn,
    });
    return r.optIn;
  },
};

export const settingsApi: SettingsApi = env.useMocks ? mockSettingsApi : realSettingsApi;
